interface props {
  className?: string;
}
export function Separator({ className }: props) {
  return <span className={`block my-1 w-5 h-[0.25px] bg-custom-gray-700 ${className}`} />;
}
